// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes HFImqAo3MI2FoxUoKWgw{from{opacity:0}to{opacity:1}}.aTIYeHdeojsr7Fmgup5g{animation:HFImqAo3MI2FoxUoKWgw .3s}", "",{"version":3,"sources":["webpack://./src/aiComponentLibrary/copyButton/copy-button.module.scss"],"names":[],"mappings":"AAEA,gCACE,KACE,SAAA,CAEF,GACE,SAAA,CAAA,CAIJ,sBACE,kCAAA","sourcesContent":["@import '@cdo/apps/mixins.scss';\n\n@keyframes fade-in {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.tooltip {\n  animation: fade-in 0.3s;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tooltip": "aTIYeHdeojsr7Fmgup5g",
	"fade-in": "HFImqAo3MI2FoxUoKWgw"
};
export default ___CSS_LOADER_EXPORT___;
